var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("div", [_vm._v(_vm._s(_vm.$ct("asked-filters")))]),
          _c(
            "w-sortable",
            {
              staticClass: "no-margin",
              attrs: {
                "target-class": "handle",
                tag: "w-list",
                items: _vm.value.AskedFilters,
              },
            },
            _vm._l(_vm.value.AskedFilters, function (filter, i) {
              return _c(
                "w-list-item",
                { key: filter.key, attrs: { "show-handle": "" } },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.getFilterText(filter))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit"),
                              expression: "$ct('common.edit')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editFilter(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.delete"),
                              expression: "$ct('common.delete')",
                            },
                          ],
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeFilter(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-list",
            { staticClass: "no-margin" },
            [
              _vm.value.AskedFilters.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("no-asked-filters"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addFilter()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("common.add")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditFilter != null
        ? _c(
            "w-modal",
            { attrs: { value: _vm.toEditFilter != null } },
            [
              _c("app-asked-filter-edit", {
                attrs: { model: _vm.model, browse: _vm.browse },
                on: {
                  cancel: function ($event) {
                    _vm.toEditFilter = null
                  },
                  confirm: function ($event) {
                    return _vm.confirmEdit()
                  },
                },
                model: {
                  value: _vm.toEditFilter,
                  callback: function ($$v) {
                    _vm.toEditFilter = $$v
                  },
                  expression: "toEditFilter",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }